<template>
  <div>
    <h5 v-html="$t('filter.titles.' + key)" />
    <b-input-group>
      <b-input-group-text>
        <font-awesome-icon :icon="icon" />
      </b-input-group-text>
      <b-select v-if="this.options" :options="this.options" v-model="selected" value-field="value" text-field="text"
        @input="transmitNewValue()" />
    </b-input-group>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    selectedYear: { type: Number, default: null },
  },
  data() {
    return {
      tKey: "filter.comparisonYear.",
      options: null,
      selected: null,
      icon: "calendar-alt",
      key: "comparisonYear",
    };
  },
  methods: {
    generateOptions() {
      var comparisonYears = new Array();
      for (var year = this.selectedYear - 1; year >= 2005; year--) {
        comparisonYears.push({
          text: year,
          value: this.selectedYear - year,
        });
      }
      this.options = comparisonYears;
      this.selected = comparisonYears[0].value;
    },
    transmitNewValue() {
      this.$emit("transmit", this.selected, this.key)
    }
  },
  created() {
    this.generateOptions();
  },
};
</script>

<style>
</style>